import { render } from "./MiniTitle.html?vue&type=template&id=0a6ac618&ts=true&external"
import script from "./MiniTitle.vue?vue&type=script&lang=ts"
export * from "./MiniTitle.vue?vue&type=script&lang=ts"

import "./MiniTitle.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__